<template>
  <tr :class="['task-' + task.id, 'order-' + task.order]">
    <td class="p0 m0 handle"><svg-handle/></td>
    <lw-cell-input
      ref="task"
      :focus="true"
      :label="'Task'"
      :name="'taskName_' + task.id"
      :id="'taskName_' + task.id"
      :align="'left'"
      :type="'text'"
      :class="'mobile taskName'"
      v-model="task.name"
      @input="editTask"
    />
    <td
      class="select"
      data-label="Role">
      <lw-select-input
        v-model="role"
        :options="roleList"
        :placeholder="'Unassigned'"
        :class="'mb0 pb0'"
        :size="'small'"
        @input="editTask"
      />
    </td>
    <td
      class="select"
      data-label="Person">
      <lw-select-input
        v-model="person"
        :options="teamList"
        :placeholder="'Unassigned'"
        :class="'mb0 pb0'"
        :size="'small'"
        @input="editTask"
      />
    </td>
    <lw-cell-input
      :label="'Likely ' + unit"
      :name="'lowEstimate_' + task.id"
      :id="'lowEstimate_' + task.id"
      :align="'right'"
      :type="'number'"
      :class="['mobile', task.highEstimate < task.lowEstimate || isNaN(task.lowEstimate) ? 'error' : '']"
      v-model.number="task.lowEstimate"
      @input="editTask"
    />
    <lw-cell-input
      :label="'High ' + unit"
      :name="'highEstimate_' + task.id"
      :id="'highEstimate_' + task.id"
      :align="'right'"
      :type="'number'"
      :class="['mobile', task.highEstimate < task.lowEstimate || isNaN(task.highEstimate) ? 'error' : '']"
      v-model.number="task.highEstimate"
      @input="editTask"
    />
    <td class="p0"><a
      v-if="isEditing"
      href=""
      class="close delete p05"
      @click.prevent="removeTask"><svg-delete/></a></td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import CellInput from '../livewires/CellInput'
import SelectInput from '../livewires/SelectInput'
import Delete from '../svgs/Delete'
import Handle from '../svgs/Handle'

export default {
  components: {
    lwCellInput: CellInput,
    lwSelectInput: SelectInput,
    svgDelete: Delete,
    svgHandle: Handle
  },
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    skill: {
      type: [Boolean, String],
      default: false
    },
    assignedTo: {
      type: [Boolean, String],
      default: false
    },
    estimate: {
      type: String,
      default: ''
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      person: '',
      role: '',
      low: '',
      high: ''
    }
  },
  computed: {
    ...mapGetters([
      'roles',
      'roleList',
      'team',
      'teamList',
      'organization'
    ])
  },
  watch: {
    skill (value) {
      this.role = value
    },
    assignedTo (value) {
      this.person = value
    }
  },
  mounted () {
    !this.assignedTo ? this.person = 'zzzzz' : this.person = this.assignedTo
    !this.skill ? this.role = 'zzzzz' : this.role = this.skill
  },
  methods: {
    editTask () {
      let low, high, role, person
      this.task.lowEstimate ? low = this.task.lowEstimate : low = 0
      this.task.highEstimate ? high = this.task.highEstimate : high = 0
      !this.role ? role = false : role = this.role
      !this.person ? person = false : person = this.person
      this.$store.dispatch('saveState', false)
      const payload = {
        id: this.task.id,
        estimate: this.estimate,
        name: this.task.name,
        role: role,
        person: person,
        lowEstimate: low,
        highEstimate: high
      }
      this.$store.dispatch('editTask', payload)
    },
    removeTask () {
      this.$store.dispatch('saveState', false)
      const payload = {
        id: this.task.id,
        estimate: this.estimate,
        organization: this.organization.id
      }
      this.$store.dispatch('removeTask', payload)
    }
  }
}
</script>

<style scoped>
  .handle {
    cursor: move;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    cursor: grab;
    padding-right: 0.4em;
  }
  .handle:active,
  .handle:focus {
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  td {
    vertical-align: middle;
  }
  td:first-child {
    padding-left: 0;
    padding-right: 0;
  }
  .select .field {
    padding-top:0.5em;
    padding-bottom:0.5em;
  }
  .delete {
    display:block;
    width: calc(var(--line) * 0.7);
    height: calc(var(--line) * 0.7);
  }
  @media only screen and (max-width: 48em) {
    .handle {
      opacity: 0;
      display: none;
    }
    tr {
      padding-top: calc(val(--line) / 2);
      padding-bottom: calc(val(--line) / 2);
    }
    td {
      margin-bottom: calc(val(--line) / 4);
    }
    td:first-child,
    td:last-child {
      display:none;
    }
    td:nth-child(2),
    .select {
      margin-top:calc(val(--line) / 2);
      grid-column: span 2;
    }
    td input,
    td select {
      width: 100%;
    }
    .select,
    .select .field {
      padding: 0;
    }
    .delete {
      display: flex;
      align-items: center;
      text-decoration: none;
      margin-top: calc(var(--line)* 0.25);
    }
    .delete:hover,
    .delete:active,
    .delte:focus {
      text-decoration: underline;
    }
    .delete:after {
      content: 'Delete';
      color: var(--dark-red);
      display: inline-block;
      font-size: var(--font-size-2);
      margin-left: 0.25em;
      font-weight: var(--semibold);
    }
  }
  @media only screen and (min-width: 48em) {
    .taskName {
      min-width: 200px;
    }
  }
</style>
